import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { DangerButton, SuccessButton } from '../../../../ui/buttons/Button'
import { Input, Radio, Select } from "../../../../ui/inputs/Input";
import { Mensaje } from "../../../mensajes2";
import { Dimmer } from "../../../spinner";
import { ProcesarNomina } from "./modalElaborarNomina";
import axios from "axios";
import { ProgressBar } from 'react-bootstrap';

export default function SeleccionarProcesar(props) {

	const nominaSel = JSON.parse(localStorage.getItem('codnomi'));
	let op = require("../../../../../src/modulos/datos");
	let token = localStorage.getItem('jwtToken');
	const [records, setRecords] = useState([]);
	const [mostrar1, setMostrar1] = useState(false);
	const [activate, setActivate] = useState(false);
	const [idPago, setidPago] = useState(false);
	const [nProPer, setNproPer] = useState(false);
	const [mensaje, setMensaje] = useState({
		mostrar: false,
		titulo: "",
		texto: "",
		icono: "",
	});

	const [progress, setProgress] = useState(0);

	const radioNomina = useRef();
	const radioOtroPago = useRef();
	const radioVacaciones = useRef();
	const txtCodPago = useRef();
	const txtOtroPago = useRef();
	const txtPeriodoDesde = useRef();
	const txtPeriodoHasta = useRef();
	const btnCaeptar = useRef();

	/*useEffect(() => {
		const fetchData = async () => {
		  // Reemplazar con la lógica para obtener el progreso de la base de datos
		  // En este ejemplo, se simula una operación con progreso que avanza de 0 a 100
		  // en un intervalo de tiempo
		  await new Promise(resolve => setTimeout(resolve, 2000)); // Simulando la llamada a la base de datos
		  const progreso = 25;
		  setProgress(progreso);
		  await new Promise(resolve => setTimeout(resolve, 2000));
		  setProgress(progreso + 25);
		  await new Promise(resolve => setTimeout(resolve, 2000));
		  setProgress(progreso + 25 + 25);
		  await new Promise(resolve => setTimeout(resolve, 2000));
		  setProgress(100);
	
		  // Aquí se puede usar axios para obtener el progreso de la base de datos
		  // const response = await axios.get('/api/progreso');
		  // setProgress(response.data.progreso);
		};
	
		fetchData();
	}, [progress]);*/

	const salir = () => {
		props.setShow(false);
		props.setTabla(0);
	};

	const procesarNomina = (body) => {
		setActivate(true);
		let endpoint = `${op.conexion}/api/nomina/procesarnomina`;
		axios
			.post(endpoint, body, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(function (response) {
				setActivate(false);
				if (response.status == 200) {
					if (response.data.mensaje === "") {
						setMostrar1(true);
					} else {
						setMensaje({ mostrar: true, titulo: 'Notificación', texto: response.data.mensaje, icono: 'informacion' });
					}
				}
				
			})
			.catch(function (error) {
				setActivate(false);
				setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});
				
			});
	};

	const handleChangeRadio = (event) => {
		//event.preventDefault();
		if (event.target.value === "2" && txtOtroPago.current.value === "") {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No hay pagos Seleccionados.', icono: 'informacion' });
			radioNomina.current.checked = true;
			radioOtroPago.current.checked = false;
			if (props.llamado === 1) {
				radioVacaciones.current.checked = false;
			}
		}
	}

	const aceptar = () => {
		var sigue = true;
		if (props.llamado === 2){
			if (txtPeriodoDesde.current.value === '') {
				setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha de Inicio no es valida.', icono: 'informacion' });
				sigue = false;
				txtPeriodoDesde.current.focus();
			} else if (txtPeriodoHasta.current.value === '') {
				setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha de Fín no es valida.', icono: 'informacion' });
				sigue = false;
				txtPeriodoHasta.current.focus();
			} else if (txtPeriodoHasta.current.value <= txtPeriodoDesde.current.value) {
				setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha de Fin (Hasta) no Puede ser Anterior o Igual a la Fecha de Inicio (Desde).', icono: 'informacion' });
				sigue = false;
				txtPeriodoDesde.current.focus();
			} 
		}
		
		if (sigue) {
			let body;
			if (props.modulo === "PROCESAR"){
				body = {
					//operacion:props.operacion,
					codnomina: JSON.parse(localStorage.getItem('codigonomina')),
					numperiodo: JSON.parse(localStorage.getItem('numperiodo'))
				};
				procesarNomina(body);
			} else if (props.modulo === "GRABAR"){

			} else if (props.modulo === "REVERSAR"){

			} else if (props.modulo === "GENERAR"){

			}
			
			
			/*let body = {
				//operacion:props.operacion,
				codnomina: txtCodNomina.current.value,
				titnomina: txtTituloNomina.current.value,
				anio: parseInt(txtAnioCurso.current.value),
				fechaini: txtPeriodoDesde.current.value,
				fechafin: txtPeriodoHasta.current.value,
				numperiodo: parseInt(txtNumPeriodo.current.value),
				desperiodo: txtDesPeriodo.current.value.trim().toUpperCase(),
				properiodo: props.operacion === 1 ? 1 : parseInt(cmbProximoPeriodo.current.value),
				intecon: radioSi.current.checked,
				codviejo: txtCodNomina.current.value,
				tipoper: parseInt(cmbSelecPeriodo.current.value),
				nstatus: parseInt(cmbStatus.current.value),
				nomusu: JSON.parse(localStorage.getItem("post")).login,
				nomper: JSON.parse(localStorage.getItem('liquidador')),
				fechasis: JSON.parse(localStorage.getItem('fechasistema')),
				periodos: JSON.stringify(periodos)
			};*/
			//alert(JSON.stringify(body))
			//actualizarNomina(body);
		}

	};

	const aceptarProcesarNomina = (modulo) => {
		props.setShow(false);
		props.setTabla(0);
	};

	const cancelarProcesarNomina = (modulo) => {
		setMostrar1(false);
		props.setShow(false);
		props.setTabla(0);
	};

	return <Modal
		size="lg"
		show={props.show}
		centered
		backdrop="static"
		keyboard={false}
		onShow={() => {
			txtCodPago.current.value = JSON.parse(localStorage.getItem("codigootropago")) === null ? "" : JSON.parse(localStorage.getItem("codigootropago")).trim();
			txtOtroPago.current.value = JSON.parse(localStorage.getItem("titulotropago")) === null ? "" : JSON.parse(localStorage.getItem("titulotropago")).trim();

		}}
	>
		<Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
			<h3 className="fw-bold m-0">{props.modulo === "PROCESAR" ? "Procesar Nominas" : props.modulo === "GRABAR" ? "Grabar Acumulados" : props.modulo === "REVERSAR" ?  "Reversar Acumulados" : "Generar Períodos"}</h3>
			<a type="button" className="fw-bold text-light fs-6" onClick={salir}>
				Salir <i className="fa fa-times ms-2"></i>
			</a>
		</Modal.Header>
		<Modal.Body className="col-12 m-0 p-2">
			<fieldset className="col-12 m-0 p-2 d-flex flex-wrap gap-2 border-azul rounded">
				<legend className="m-0 w-auto float-none">Seleccionar Tipo de Pago</legend>
				<div className="col-auto m-0 p-0">
					<Radio label='Nomina' ref={radioNomina} name='tipoPago' id='tipoPago1' defaultChecked value="1" onChange={handleChangeRadio} />
				</div>
				<div className="col-auto m-0 p-0">
					<Radio label='Otro Pago' ref={radioOtroPago} name='tipoPago' id='tipoPago2' value="2" onChange={handleChangeRadio} />
				</div>
				{props.llamado === 1 ?
					<div className="col-auto m-0 p-0">
						<Radio label='Vacaciones' ref={radioVacaciones} name='tipoPago' id='tipoPago3' value="3" onChange={handleChangeRadio} />
					</div>
					: ""}
				<div className="col-12 m-0 p-0 d-flex gap-2">
					<Input ref={txtOtroPago} readOnly />
					<div className="col-3 m-0 p-0">
						<Input label='Cod. Otro Pago:' ref={txtCodPago} readOnly />
					</div>
				</div>
				{props.llamado === 2 ?
					<div className="col-12 m-0 p-0 d-flex gap-2">
						<div className="col-4 m-0 p-0">
							<Input type="date" label="Periodo &nbsp; &nbsp; Desde:" ref={txtPeriodoDesde} onKeyUp={(e) => { if (e.which === 13) { txtPeriodoHasta.current.focus() } }} />
						</div>
						<div className="col-4 m-0 p-0 pl-1">
							<Input type="date" label="Hasta:" ref={txtPeriodoHasta} onKeyUp={(e) => { if (e.which === 13) { btnAceptar.current.focus() } }} />
						</div>
						<div className="col-4 m-0 p-0 pl-2"></div>
					</div>
					: ""}
			</fieldset>
		</Modal.Body>
		<Modal.Footer>
			<SuccessButton ref={btnCaeptar} onClick={aceptar}>Aceptar</SuccessButton>
			<DangerButton onClick={salir}>Cancelar</DangerButton>
			{/*<div>
      			<h1>Barra de Progreso</h1>
      			<ProgressBar now={progress} label={`${progress}%`} />
    		</div>*/}
		</Modal.Footer>
		<Dimmer active={activate} inverted>
		</Dimmer>
		<Mensaje
			mensaje={mensaje}
			onHide={() => {
				mensaje.titulo === "Exito."
					? cerrarModal()
					: setMensaje({
						mostrar: false,
						titulo: "",
						texto: "",
						icono: "",
					});
			}}
		/>
		<ProcesarNomina
			show={mostrar1}
			llamado={0}
			onHideCancela={cancelarProcesarNomina}
			onHideAcepta={aceptarProcesarNomina}
		/>
	</Modal>
}